import cafe24UserLogin from "./conditions/cafe24-user-login";
import imwebUserLogin from "./conditions/imweb-user-login";
import makeshopUserLogin from "./conditions/makeshop-user-login";
import shopifyUserLogin from "./conditions/shopify-user-login";
import sixshopUserLogin from "./conditions/sixshop-user-login";
import createCustomCampaignTargetManager from "./create-manager";

const customCampaignTargetManager = createCustomCampaignTargetManager();

customCampaignTargetManager.register(sixshopUserLogin);
customCampaignTargetManager.register(cafe24UserLogin);
customCampaignTargetManager.register(imwebUserLogin);
customCampaignTargetManager.register(shopifyUserLogin);
customCampaignTargetManager.register(makeshopUserLogin);

/**
 * 샵바이 , 고도몰은 로그인 전후가 소스보기시 기준으로 변경되는 내용이 없음
 * 샵바이 기본의 경우 로그인시 유저정보를 https://api.e-ncp.com/profile?_=고유숫자를 통해 가져오고
 * 로그인 유무에 대해서는 shop.isLogin()를 통해 식별하고 있지만 자바스크립트 동작 이후 시점이라 로그인 유무를 식별하는데 어려움이 있음
 */

export default customCampaignTargetManager;
